import React, {
  ChangeEvent,
  ComponentType,
  FocusEvent,
  ReactNode
} from 'react';
import { Input, Label, LabelSpan } from '../../../components/Form';

interface FormInputProps<H = HTMLInputElement> {
  // correct typing was nearyl impossible
  // and it could end up too complicated
  // so we opted for `any`
  component?: ComponentType<any>;
  label?: ReactNode;
  required?: boolean;
  type?: string;
  name: string;
  placeholder?: string;
  onChange: (e: ChangeEvent<H>) => void;
  onBlur: (e: FocusEvent<H>) => void;
  value: string;
  children?: ReactNode;
  margin?: boolean;
  error: boolean;
  // additional props for the underlying `component`
  [additionalProps: string]: any;
}

export function FormInput<H = HTMLInputElement>({
  component: Component = Input,
  label,
  required,
  margin,
  ...props
}: FormInputProps<H>) {
  return (
    <Label margin={margin}>
      {label && <LabelSpan required={!!required}>{label}</LabelSpan>}
      <Component {...props} />
    </Label>
  );
}
